import { get } from "../../Utils/Crypto";

const useSidebarExpanded = () => {
    return get(`expanded`);

}

export {useSidebarExpanded}